// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.freemium.RentalManagerUserFreemiumV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserFreemiumV2WebApiHandler_charge,
  RentalManagerUserFreemiumV2WebApiHandler_startPaymentMethodSession,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  FreemiumChargeRequestDto,
  FreemiumChargeV2ResponseWebDto,
  FreemiumStartPaymentMethodSessionRequestDto,
  FreemiumStartPaymentMethodSessionV2ResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserFreemiumV2WebApiHandler_charge_Args {
  postData: FreemiumChargeRequestDto;
}

export type RentalManagerUserFreemiumV2WebApiHandler_charge_Options = UseMutationOptions<
  FreemiumChargeV2ResponseWebDto,
  unknown,
  RentalManagerUserFreemiumV2WebApiHandler_charge_Args
>;

/**
 * Charge credit card
 */
export const useRentalManagerUserFreemiumV2WebApiHandler_charge = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserFreemiumV2WebApiHandler_charge_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserFreemiumV2WebApiHandler_charge_Args) =>
      RentalManagerUserFreemiumV2WebApiHandler_charge(args.postData, httpClient),
  });
};

export interface RentalManagerUserFreemiumV2WebApiHandler_startPaymentMethodSession_Args {
  postData: FreemiumStartPaymentMethodSessionRequestDto;
}

export type RentalManagerUserFreemiumV2WebApiHandler_startPaymentMethodSession_Options = UseMutationOptions<
  FreemiumStartPaymentMethodSessionV2ResponseWebDto,
  unknown,
  RentalManagerUserFreemiumV2WebApiHandler_startPaymentMethodSession_Args
>;

/**
 * Start payment method session to load the credit card iframe
 */
export const useRentalManagerUserFreemiumV2WebApiHandler_startPaymentMethodSession = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserFreemiumV2WebApiHandler_startPaymentMethodSession_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserFreemiumV2WebApiHandler_startPaymentMethodSession_Args) =>
      RentalManagerUserFreemiumV2WebApiHandler_startPaymentMethodSession(args.postData, httpClient),
  });
};
